module.exports = __webpack_public_path__ + "media/passed150Sound.05807edb.wav";